<template>
    <div class="cc-selected-payment" v-if="selectedPayment">
        <div class="cc-selected-payment__title">{{ translations['Selected payment'] }}</div>
        <div class="cc-selected-payment__information">{{ currentPayment.title }}</div>
        <div class="cc-selected-payment__price">{{ price }}</div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedPayment: state => state.selectedPayment,
                currentPayment: state => state.currentPayment,
                useVat: state => state.config.use_vat,
            }),
            price: function () {
                if (this.currentPayment.free) {
                  return this.translations['Free'];
                }
                if (this.useVat) {
                  return this.currentPayment.formattedPrices.price;
                }
                return this.currentPayment.formattedPrices.price_without_tax;
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/selected-payment";
</style>
